import { Link } from '@mantine/tiptap';

/**
 * Marque lien du texte riche, augmentée d'un `data-link-id`.
 *
 * Un lien choisi dans la banque **copie** son adresse dans le HTML, comme
 * partout ailleurs dans le chantier n°16 : le site publié n'appelle rien et ne
 * casse pas si le lien disparaît de la banque. L'identifiant est le seul moyen
 * de retrouver, plus tard, de quel lien cette adresse venait — c'est lui qui
 * permet au bouton « Rafraîchir » de la remettre à jour.
 *
 *   <a href="https://calendly.com/nico" data-link-id="7" target="_blank">…</a>
 *
 * Une adresse tapée à la main n'en porte pas : `data-link-id` est absent, et
 * le rafraîchissement laisse le lien tranquille.
 */
export const BANK_LINK_ATTRIBUTE = 'data-link-id';

export const BankLink = Link.extend({
  parseHTML() {
    return [
      { tag: 'a[data-download-id]', getAttrs: (element) => element.getAttribute('href') ? false : {} },
      ...this.parent(),
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const rendered = this.parent({ HTMLAttributes });
    if (!HTMLAttributes['data-download-id']) return rendered;
    const { href, target, ...attributes } = rendered[1];
    return [rendered[0], { ...attributes, ...(href ? { href } : {}) }, ...rendered.slice(2)];
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      download: {
        default: null,
        parseHTML: (element) => element.hasAttribute('download') ? element.getAttribute('download') : null,
        renderHTML: (attributes) => attributes.download === null ? {} : { download: attributes.download },
      },
      downloadId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-download-id'),
        renderHTML: (attributes) => attributes.downloadId ? { 'data-download-id': attributes.downloadId } : {},
      },
      documentId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-document-id'),
        renderHTML: (attributes) => attributes.documentId ? { 'data-document-id': attributes.documentId } : {},
      },
      downloadForm: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-download-form'),
        renderHTML: (attributes) => attributes.downloadForm ? { 'data-download-form': attributes.downloadForm } : {},
      },
      linkId: {
        default: null,
        parseHTML: (element) => element.getAttribute(BANK_LINK_ATTRIBUTE) || null,
        renderHTML: (attributes) => (attributes.linkId
          ? { [BANK_LINK_ATTRIBUTE]: String(attributes.linkId) }
          : {}),
      },
    };
  },
});

export default BankLink;
